/* @ngInject */

export default ($sce, $state, $rootScope, $scope, $timeout, webpage, authenticationService) => {
  let devURL = 'https://dev-ll.salestrekker.com:9170/';
  if (process?.env?.ST_SERVICES_MARKETING_ENDPOINT) {
    devURL = process?.env?.ST_SERVICES_MARKETING_ENDPOINT;
  }

  $scope.Model = {
    url: $sce.trustAsResourceUrl(
      $rootScope.isDev() ? devURL : 'https://marketing.svc.salestrekker.com/'
    ),
    isReady: false
  };

  if (!authenticationService.isAdministrator()) {
    $state.transitionTo('dashboard');
  }

  const iframe = angular.element('#marketingIFrame');
  iframe.on('load', () => {
    iframe[0].contentWindow.postMessage(authenticationService.tokenGet(), '*');

    webpage.pageTitle('Marketing');
    $timeout(() => {
      $scope.Model.isReady = true;
    });
  });
};
